import React from 'react';
import { Tag, Tooltip } from 'antd';
import { MobileOutlined, DesktopOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { CANAL_MAP } from '../../../../variables/constants';

/**
 * Canal de saisie du dossier : back-office ou application mobile.
 *
 * Les dossiers anterieurs a CBConnect Mobile n'ont pas de colonne `canal` peuplee ;
 * le backend leur applique WEB par defaut. Un `canal` absent se lit donc comme WEB,
 * jamais comme « inconnu » - d'ou l'absence de rendu d'un etat indetermine.
 *
 * Par defaut le badge ne s'affiche QUE pour le mobile (`seulementMobile`) : marquer
 * les 7000 dossiers back-office d'une pastille « Back-office » n'apprend rien et
 * noierait justement le signal qu'on cherche a faire ressortir.
 */
export default function BadgeCanal({ canal, seulementMobile = true, size = 'md' }) {
  const { t } = useTranslation('dossierSinistre');
  const valeur = canal || 'WEB';
  if (seulementMobile && valeur !== 'MOBILE') return null;

  const meta = CANAL_MAP[valeur] || { label: valeur, color: 'default' };
  const mobile = valeur === 'MOBILE';
  const petit = size === 'sm';

  return (
    <Tooltip
      title={mobile
        ? t('badgeCanal.declareMobile')
        : t('badgeCanal.saisiBackOffice')}
    >
      <Tag
        color={meta.color}
        icon={mobile ? <MobileOutlined /> : <DesktopOutlined />}
        style={{
          borderRadius: 14,
          fontSize: petit ? 10 : 11,
          fontWeight: 700,
          marginInlineEnd: 0,
        }}
      >
        {meta.label}
      </Tag>
    </Tooltip>
  );
}
